import { Dispatch, SetStateAction } from "react";
import { AuthClient } from "../utilities/backend/client";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeToken, setRole, setToken } from "../utilities/redux/actions";
import { RootState } from "../utilities/redux/store";

const useAutoLogin = ({ setLoading }: { setLoading?: Dispatch<SetStateAction<boolean>> }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authClient = new AuthClient();
    const storedToken = useSelector((state: RootState) => state.token.token);

    const proceedToLogin = async () => {

        if (storedToken) return;

        const email = localStorage.getItem("email");
        const password = localStorage.getItem("password");

        if (!email || !password) {
            console.error("No stored credentials found. Redirecting to login...");
            navigate("/login");
            return;
        }

        setLoading && setLoading(true);

        try {
            const response = await authClient.auth_Authenticate({ email, password });

            if (!response || !response.data) {
                throw new Error("Invalid response from server");
            }

            const token = await response?.data.text();
            if (token !== undefined) {
                dispatch(setRole(JSON.parse(atob(token.split(".")[1])).role));
                dispatch(setToken(JSON.parse(token).token));
            } else {
                dispatch(removeToken());
            }
            localStorage.removeItem("email");
            localStorage.removeItem("password");
        } catch (error) {
            console.error("Login failed:", error);
            dispatch(removeToken());
            navigate("/login");
        } finally {
            setLoading && setLoading(false);
        }
    };

    return proceedToLogin;
};

export default useAutoLogin;
